export default __webpack_public_path__ + "images/66423f2c6ed8294102a25041b03d7644.png";